import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({
    name: 'safeResourceUrl',
    standalone: true
})
export class SafeResourceUrlPipe implements PipeTransform {
  constructor(private dom: DomSanitizer) {}
  transform(value) {
    return this.dom.bypassSecurityTrustResourceUrl(value);
  }
}
